import { Box, Text } from '@factorialco/deprecated-design-system'
import { Carousel, Widget } from '@factorialco/factorial-one-react/dist/experimental'
import { AtsFavouriteJobPostingItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { FavouriteJobCard } from './FavouriteJobCard'

interface FavouritesListProps {
  favouriteJobs: AtsFavouriteJobPostingItemFragment[] | null | undefined
  isAddingFavourite: boolean
  deletingFavouriteJob: number | null
  onDeleteFavourite: (jobId: number | null) => void
  loading?: boolean
}

export const FavouritesList = ({
  favouriteJobs,
  isAddingFavourite,
  deletingFavouriteJob,
  onDeleteFavourite,
  loading = false,
}: FavouritesListProps) => {
  const hasFavourites = favouriteJobs?.length ? favouriteJobs.length > 0 : false

  if (!hasFavourites && !isAddingFavourite && !loading) return null

  return (
    <Box gap="s16">
      <Text.Header2>{i18n.t('ats.jobs.favourites.section_title')}</Text.Header2>
      <Box paddingX="s4">
        <Carousel columns={{ xl: 6, lg: 4, md: 2, sm: 2, xs: 2 }}>
          {loading ? (
            <Widget.Skeleton />
          ) : (
            favouriteJobs?.map((favouriteJob) => (
              <FavouriteJobCard
                key={favouriteJob.id}
                favouriteJob={favouriteJob}
                deletingFavouriteJob={deletingFavouriteJob}
                onDeleteFavourite={onDeleteFavourite}
              />
            ))
          )}
          {(isAddingFavourite || loading) && <Widget.Skeleton />}
        </Carousel>
      </Box>
    </Box>
  )
}
